import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';

import cardImage1 from 'src/public/img/group_252.svg';
import cardImage3 from 'src/public/img/group_253.svg';
import cardImage2 from 'src/public/img/group_254.svg';
import image from 'src/public/img/marginalia-page-not-found.svg';

import { BrandWrapper } from 'src/modules/onboarding/components/BrandWrapper';
import { Button } from 'src/shared/components/Button';
import { color, font } from 'src/shared/styles/variables';

const Wrapper = styled.div({
    maxWidth: 492,
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    paddingBottom: 100,
});

const HeaderText = styled.h3({
    color: color.pickledBluewood,
    marginBottom: 20,
    textAlign: 'center',
    ...font.black(font.size.extraLarge),
});

const DescriptionText = styled.p({
    color: color.blueBayoux,
    marginBottom: 16,
    lineHeight: '26px',
    textAlign: 'center',
    ...font.book(font.size.medium),
});

const Image = styled.img({
    width: 250,
});

const CardWrapper = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    border: `2px solid ${color.catskillWhite}`,
    padding: '20px 12px 20px 24px',
    marginTop: 8,
    borderRadius: 4,
});

const CardTitle = styled.p({
    color: color.pickledBluewood,
    lineHeight: '22px',
    marginBottom: 2,
    ...font.heavy(font.size.medium),
});

const CardDescription = styled.p({
    color: color.blueBayoux,
    lineHeight: '22px',
    ...font.book(font.size.medium),
});

const CardImageWrapper = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 62,
    height: 62,
    borderRadius: '50%',
    backgroundColor: 'rgba(45, 128, 226, 0.1)',
});

export const cards = [
    {
        type: 'progress',
        icon: cardImage1,
    },
    {
        type: 'care',
        icon: cardImage2,
    },
    {
        type: 'options',
        icon: cardImage3,
    },
];

export const ReTriageIntroPage: React.FC<RouteComponentProps> = ({ history }) => {
    const { t } = useTranslation();
    useEffect(() => {
        ReactGA.event({
            category: 'Re-triage flow',
            action: 'Visited intro page',
            label: 'retriage_overview_visited',
        });
    }, []);

    return (
        <BrandWrapper>
            <Wrapper>
                <Image src={image} />
                <HeaderText>{t('retriage:intro_page.title')}.</HeaderText>
                <DescriptionText>{t('retriage:intro_page.description')}</DescriptionText>

                {cards.map(card => (
                    <CardWrapper key={card.type}>
                        <div>
                            <CardTitle>
                                {t(`retriage:intro_page.cards.${card.type}.title`)}
                            </CardTitle>
                            <CardDescription>
                                {t(`retriage:intro_page.cards.${card.type}.description`)}
                            </CardDescription>
                        </div>
                        <CardImageWrapper>
                            <img src={card.icon} />
                        </CardImageWrapper>
                    </CardWrapper>
                ))}

                <Button
                    onClick={() => history.push('/re-triage-categories')}
                    widthPercentage={100}
                    marginTop={24}
                >
                    {t('common.continue')}
                </Button>
            </Wrapper>
        </BrandWrapper>
    );
};
